import { Checkbox } from '@mui/material';
import React, { useEffect, useState } from 'react';
import colors from '../../colors';
import Label from '../Label.js';
import MultiSearchSelect from '../MultiSearchSelect';
import OutlineButton from './Buttons/outline/OutlinedModalButton';
import ModalContainer from './ModalContainer';

function EditMembersModal({ title, inputLabel, isVisible, setIsVisible, options, defaultSelected, dataCallback, showSelectAll = true }) {
    const [tempSelected, setTempSelected] = useState(defaultSelected);
    const [selectAll, setSelectAll] = useState(false);

    useEffect(() => {
        setSelectAll(tempSelected.length === options.length);
    }, [tempSelected, options])

    useEffect(() => {
        setTempSelected(defaultSelected);
    }, [defaultSelected])

    const handleSave = () => {
        dataCallback(tempSelected);
        setIsVisible(false);
    };

    const modalContainerStyles = {
        paddingBottom: '40px',
    }

    const handleSelectAll = () => {
        if (selectAll) setTempSelected([]);
        else setTempSelected(options);
    }

    const handleClose = () => setTempSelected(defaultSelected);

    const checkboxContainerStyles = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 15,
        margin: -15,
        cursor: 'pointer',
    }

    const checkboxStyles = {
        color: colors.green,
        fontSize: '30px',
    }

    const checkboxLabelStyles = {
        fontFamily: 'Jost',
        fontSize: 15,
    }

    return (
        <ModalContainer isVisible={isVisible} setIsVisible={setIsVisible} title={title} style={modalContainerStyles} onClose={handleClose}>
            {showSelectAll && <div style={checkboxContainerStyles} onClick={handleSelectAll}>
                <Checkbox
                    sx={checkboxStyles}
                    checked={selectAll}
                    label="Select All"
                    color='success'
                />
                <span style={checkboxLabelStyles}>Select All</span>
            </div>}
            <div style={{ marginBottom: '35px', maxWidth: '90%' }}>
                <Label>{inputLabel}</Label>
                <MultiSearchSelect
                    setSelected={setTempSelected}
                    selected={tempSelected}
                    options={options}
                    simple={false}
                    maxMenuHeight={120}
                />
            </div>
            <OutlineButton color={colors.green} label={'Save'} onClick={handleSave}></OutlineButton>
        </ModalContainer>
    )
}

export default EditMembersModal;
